import Phone from './PhoneInput';

export default Phone;
